import { verificationChallengesPath } from "src/routes";

type VerifyPhoneNumberResult = { verified: boolean; error: string | null; };

const verifyPhoneNumber = async (code: string): Promise<VerifyPhoneNumberResult> => {
  const requestPath = verificationChallengesPath();
  const result = await fetch(requestPath, {
    method: "PATCH",
    credentials: "include",
    body: JSON.stringify({
      code,
      authenticity_token: (document.querySelector("meta[name='csrf-token']") as HTMLMetaElement)?.content || "",
    }),
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
  });

  return await result.json() as VerifyPhoneNumberResult;
}

export { verifyPhoneNumber, VerifyPhoneNumberResult }
